export { default } from './ForecastLabel';
